/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GenerateReportsResp } from '../models/generate-reports-resp';
import { GenerateReportsRespReq } from '../models/generate-reports-resp-req';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation generateReports
   */
  static readonly GenerateReportsPath = '/report';

  /**
   * Get a report
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `generateReports()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateReports$Response(params: {
    body: GenerateReportsRespReq
  }): Observable<StrictHttpResponse<GenerateReportsResp>> {

    const rb = new RequestBuilder(this.rootUrl, ReportService.GenerateReportsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GenerateReportsResp>;
      })
    );
  }

  /**
   * Get a report
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `generateReports$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  generateReports(params: {
    body: GenerateReportsRespReq
  }): Observable<GenerateReportsResp> {

    return this.generateReports$Response(params).pipe(
      map((r: StrictHttpResponse<GenerateReportsResp>) => r.body as GenerateReportsResp)
    );
  }

}
